import { ScoreMeterIcon } from 'static/icons';
import { Heading, Modal, Text } from 'components';
import { FontSize, FontWeight } from 'commons';
import { ScoreDescription, ScoreModalContent } from './components';
import * as S from './styles';

interface Props {
  score: number;
  startDate: string;
  endDate: string;
}

const SPECIAL_SCORE = 6;

export function ScoreDisplay({ score, startDate, endDate }: Props) {
  const isSpecialScore = score === SPECIAL_SCORE;

  return (
    <S.Main>
      <S.Wrapper $isSpecialScore={isSpecialScore}>
        <S.ScoreWrapper $score={score}>
          <Heading
            as="h2"
            size={FontSize.font60}
            weight={FontWeight.bold}
            className="score"
          >
            {score < 10 ? `0${score}` : score}
          </Heading>

          <Heading as="h1" size={FontSize.font20} weight={FontWeight.medium}>
            Nível de atendimento
          </Heading>

          <Text size={FontSize.font12}>
            {startDate} a {endDate}
          </Text>
        </S.ScoreWrapper>

        <ScoreMeterIcon />

        <S.PoiterWrapper $score={score}>
          <div className="pointer" />
        </S.PoiterWrapper>
      </S.Wrapper>

      <S.InfoWrapper>
        <ScoreDescription score={score} />

        <Modal
          modalContent={<ScoreModalContent isSpecialScore={isSpecialScore} />}
        >
          <S.AnchorStyle>Como avançar de nível</S.AnchorStyle>
        </Modal>
      </S.InfoWrapper>
    </S.Main>
  );
}
